var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedbackGold = function SvgFeedbackGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF1DC",
    strokeWidth: 1.5,
    d: "M1.8 1.25h14.4c.58 0 1.05.47 1.05 1.05v10.8c0 .58-.47 1.05-1.05 1.05H4.346a2.55 2.55 0 0 0-1.804.746L.75 16.69V2.299c0-.579.47-1.049 1.05-1.049Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF1DC",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.012 3.95v3.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10.5,
    r: 0.662,
    fill: "#FFF1DC",
    stroke: "#FFF1DC",
    strokeWidth: 0.676
  })));
};
export default SvgFeedbackGold;